import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'
import request from 'Root/request'

import { colors } from 'Constants'
import { getReport, getReportLevel } from '../helpers'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import MessageOfficeReport from './components/MessageOfficeReport'

import { useStore } from 'laco-react'
import { ReportSortingStore } from 'Store'

export default ({ appCode }) => {
  const reportSortingState = useStore(ReportSortingStore)
  const [
    { startDate, endDate, officeId, patientRef, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reports, setReports] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)

  const title = getReportLevel(officeId, patientRef)

  useEffect(async () => {
    const categories = await request('/info/message-categories/list')
    const report = await getReport('/reports/messages/get', {
      appCode,
      startDate,
      endDate,
      officeId,
      patientRef,
      showArchivedOffices,
      includeAggregation: true
    })

    setReports(report)
    if (categories.data) setCategories(categories.data)
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`${title} Message Report`}
        csvUrl="/reports/messages/csv"
        csvPayload={reportSortingState}
        appCode={appCode}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reports.map(report => (
        <MessageOfficeReport report={report} categories={categories} />
      ))}
    </>
  )
}
